module.exports = __webpack_public_path__ + "assets/img/11.357b103f.png";